<template>
	<el-form ref="form" :model="root_application" :rules="validation_rules" label-position="top" class="note-card">
		<h1>Fair Market Value</h1>
		<p><b><i>Note: Greenbelt funds may only be used to purchase interest in lands at or below fair market value pursuant to a certified appraisal.</i></b> Providing a <b>FULL</b> appraisal is the preferred method of substantiating Fair Market Value. However, if an appraisal is not attached, an adequate substantiation of estimated Fair Market Value must be provided. A qualified and competent appraisal establishing fair market value and/or the value of the proposed easement will be required prior to closing. Date of the appraisal cannot be more than one year prior to the date County Council approves the greenbelt project unless otherwise approved by the County. Also, an appraisal may be required at any time during the review of the application. Not providing an appraisal may cause the project to be deferred to another funding cycle. The County reserves the right to order a separate appraisal on the subject property.</p>
		<p>
			If available, attach the full appraisal (not just a summary) to the application
		</p>
		<el-form-item prop="fair_market_value.is_including_appraisal" label="Do you plan on including an appraisal with your application?">
			<el-radio-group v-model="is_including_appraisal">
				<el-radio :label="true">Yes</el-radio>
				<el-radio :label="false">No</el-radio>
			</el-radio-group>
		</el-form-item>
		<template v-if="is_including_appraisal">
			<el-form-item prop="fair_market_value.appraised_value" label="Appraised fair market value">
				<el-input v-model="appraised_value" v-currency="money"/>
			</el-form-item>
			<upload-non-image-alt  v-on:show-modal="showModal" id="attachments" v-on:validation-needed="validateField" :item="appraisal_attachment"/>
		</template>
		<template v-else-if="is_including_appraisal === false">
			<el-form-item prop="fair_market_value.estimated_value" label="Enter the estimated fair market value">
				<el-input v-model="estimated_value" v-currency="money"/>
			</el-form-item>
			<el-form-item prop="fair_market_value.value_estimation_description" label="Describe the method used to determine the estimated fair market value">
				<el-input v-model="value_estimation_description" type="textarea" :autosize="input_config.textarea_autosize"/>
			</el-form-item>
		</template>
		<p>Charleston County Greenbelt Program does not fund the value of existing structures. However, the applicant may fund the value of the structures and this amount will be considered applicant match. If the property contains structures, the appraisal must include separate values for land value and value of structures.</p>
		<el-form-item prop="fair_market_value.land_has_structures" label="Does the land contain structures">
			<el-radio-group v-model="land_has_structures">
				<el-radio :label="true">Yes</el-radio>
				<el-radio :label="false">No</el-radio>
			</el-radio-group><br><br>
			<p>If the property contains structures, the appraisal must include a separate raw land value and value for the structures.</p>
		</el-form-item>
		<template v-if="land_has_structures">
			<el-form-item prop="fair_market_value.value_of_structures" label="Appraised or estimated value of the structures">
				<el-input v-model="value_of_structures" v-currency="money"/>
			</el-form-item>
			<el-form-item prop="fair_market_value.structure_descriptions" label="Describe the type(s) of structures currently on the property and provide estimated total square footage. Include any current or planned uses of these structures.">
				<el-input v-model="structure_descriptions" type="textarea" :autosize="input_config.textarea_autosize"/>
			</el-form-item>
		</template>
		<el-dialog
		title=""
		:visible.sync="centerDialogVisible"
		width="30%"
		center>
		<p v-html="this.iObj.instructionalTxt"/>
	</el-dialog>
</el-form>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { mapSimpleValidation } from '@/js/utilities/validation-mapper.js';

import validation_mixin from '@/js/mixins/validation-mixin.js';
import money_mixin from '@/js/mixins/money-mixin.js';

export default {
	mixins: [money_mixin, validation_mixin],
	computed: {
		...mapState('application', {
			root_application: state => state
		}),
		...mapFields('application/fair_market_value', [
			'is_including_appraisal', 'appraised_value', 'estimated_value', 'value_of_structures', 'value_estimation_description', 'land_has_structures', 'structure_descriptions'
		])
	},
	methods: {
		showModal(itemObj){
			if(itemObj.instructionalTxt != ''){
				this.iObj = itemObj;
				this.centerDialogVisible = true;
			}
		},
		validateField(field){
			this.$refs.form.validateField(field);
		}
	},
	data(){
		return {
			centerDialogVisible: false,
			iObj:Object,
			appraisal_attachment: {
				name:'Appraisal',
				scoped: true,
				category: 'appraisals',
				isImg: false,
				isExternal:false,
				//resourceWord:'',
				//resourceLink:'',
				//instructionalTxt: "One full paper copy of the appraisal must be submitted with the application. If available, attach the full appraisal (not just a summary) to the application."
			},
			validation_rules: {
				...mapSimpleValidation([
					'fair_market_value.is_including_appraisal', 'fair_market_value.appraised_value', 'attachments.appraisals', 'fair_market_value.estimated_value', 'fair_market_value.value_estimation_description', 'fair_market_value.land_has_structures', 'fair_market_value.value_of_structures', 'fair_market_value.structure_descriptions'
				])
			}
		}
	}
}
</script>


<style>
em{
	font-weight:bold;
	text-decoration: underline;
}
</style>
